export const ui_ko = {
  'loading-spinner': {
    'initial-message': {
      title: '잠시만 기다려주세요!',
      description: '요청을 처리하는 데 몇 분 정도 더 걸릴 수 있습니다.',
    },
  },
  modal: {
    title: {
      type: {
        error: '오류',
        success: '성공',
        alert: '경고',
        warning: '경고',
      },
    },
    button: {
      cancel: '취소',
      confirm: '확인',
    },
  },
};
